// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/patients/modules/patients-detail/components/edit-patient/components/patient-merge-modal/patient-merge-modal.less
// module id = 3779
// module chunks = 0